import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { useDismissibleBanner } from "hooks/use-dismissible-banner.hook";

const BANNER_KEY = "suno_scribe_recording_sessions_banner_v1_";

export const RECORDING_SESSIONS_INFO_TEXT =
  "You can Resume recording, add Scribe Context, or remove unwanted sessions before clicking Complete Scribe.";

type PausedRecordingSessionsInfoBannerProps = {
  userId?: number;
};

export default function PausedRecordingSessionsInfoBanner({
  userId
}: Readonly<PausedRecordingSessionsInfoBannerProps>) {
  const { visible: bannerVisible, dismiss } = useDismissibleBanner({
    storageKey: BANNER_KEY,
    userId: userId != null ? String(userId) : "",
    enabled: userId != null,
    datadogActions: {
      shown: "scribe_recording_sessions_banner_shown",
      dismissed: "scribe_recording_sessions_banner_dismissed"
    }
  });

  const showBanner = userId != null && bannerVisible;

  if (!showBanner) {
    return null;
  }

  return (
    <Box sx={{ flexShrink: 0, width: "calc(100% - 32px)" }}>
      <Alert
        severity="info"
        sx={{ mt: 1, width: "100%" }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => dismiss({ source: "banner_got_it" })}
            aria-label="Dismiss recording sessions announcement"
          >
            Got&nbsp;it
          </Button>
        }
      >
        {RECORDING_SESSIONS_INFO_TEXT}
      </Alert>
    </Box>
  );
}
